var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Spacer, { ESpacerDirection, ESpacerWeight, } from "@rentiohq/shared-frontend/dist/components/components/Spacer";
import * as documentUtils from "@rentiohq/shared-frontend/dist/reduxV2/documents/document.utils";
import { EDocumentPackageSignerStatus } from "@rentiohq/shared-frontend/dist/types/documentPackage.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { getTypeData } from "../../../../utils/document";
import { DocumentFetchListItem } from "../../../DocumentFetchListItem";
import { Icon } from "../../../Icon";
import { ResourceListItem } from "../../../ResourceList";
import { TextStyle } from "../../../TextStyle";
var SignersInfo = function (_a) {
    var incompleteSignersCount = _a.incompleteSignersCount, signersCount = _a.signersCount;
    return (_jsxs(_Fragment, { children: [_jsx(Spacer, { weight: ESpacerWeight.W08, direction: ESpacerDirection.Horizontal }), _jsx(Icon, { source: "contentPenWrite", size: "small", color: incompleteSignersCount > 0 ? "yellow" : "green" }), _jsx(Spacer, { weight: ESpacerWeight.W04, direction: ESpacerDirection.Horizontal }), _jsxs(TextStyle, { variation: ["code", incompleteSignersCount > 0 ? "warn" : "positive"], size: "small", children: [signersCount - incompleteSignersCount, "/", signersCount] })] }));
};
export var InternalDocumentListItem = function (_a) {
    var item = _a.item, files = _a.files, disabled = _a.disabled, _b = _a.showActions, showActions = _b === void 0 ? true : _b, setQueryParamValue = _a.setQueryParamValue, onChangeHandler = _a.onChangeHandler;
    var getDocumentActions = function (document) {
        if (!showActions)
            return [];
        var actions = [
            {
                media: _jsx(Icon, { source: getTypeData(document.mimeType || "").icon }),
                content: getLocalizedText("document.button.view_document"),
                onClick: function () {
                    setQueryParamValue({ documentId: document.id });
                },
            },
        ];
        if (!disabled) {
            actions.push({
                media: _jsx(Icon, { source: "bin", color: "red" }),
                content: (_jsx(TextStyle, { variation: "negative", children: getLocalizedText("system.remove") })),
                onClick: function () {
                    onChangeHandler(__spreadArray([], files, true).filter(function (x) { return x !== item; }));
                },
            });
        }
        return actions;
    };
    return (_jsx(DocumentFetchListItem, { documentId: item, fetchDocumentPackage: true, renderDocument: function (document, documentPackage) {
            var signersCount = 0;
            var incompleteSignersCount = 0;
            if (documentPackage) {
                signersCount = documentPackage.signers.length;
                incompleteSignersCount = documentPackage.signers.filter(function (signer) { return signer.status !== EDocumentPackageSignerStatus.Finished; }).length;
            }
            return (_jsxs(ResourceListItem, { item: document, media: _jsx(Icon, { source: getTypeData(document.mimeType || "").icon, size: "mediumLarge" }), variation: incompleteSignersCount > 0 ? "warning" : undefined, mediaSize: "mediumLarge", boxProps: { p: 2 }, actions: getDocumentActions(document), children: [_jsx("div", { children: document.filename }), _jsxs("div", { style: {
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "baseline",
                        }, children: [_jsx(TextStyle, { variation: "subdued", size: "small", children: documentUtils.getDocumentCategoryName(document.categoryId) }), documentPackage && signersCount > 0 && (_jsx(SignersInfo, { signersCount: signersCount, incompleteSignersCount: incompleteSignersCount }))] })] }));
        } }));
};
